import { render, staticRenderFns } from "./eLearning.vue?vue&type=template&id=f233e060&scoped=true&"
import script from "./eLearning.vue?vue&type=script&lang=js&"
export * from "./eLearning.vue?vue&type=script&lang=js&"
import style0 from "./eLearning.vue?vue&type=style&index=0&id=f233e060&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f233e060",
  null
  
)

export default component.exports